import { axiosInstance } from "@/pages/auth/auth.context";
import { ContactDTO } from "@/types/contact";

/**
 * Contacts belong to the client, but the bid page only knows the event, so it
 * reaches them through the event route. Both go to the same records.
 */
export const contactService = {
  listForEvent: async (eventId: string): Promise<ContactDTO[]> => {
    const res = await axiosInstance.get<ContactDTO[]>(
      `event/${eventId}/contacts`,
    );
    return res.data;
  },

  /**
   * Sends the whole list as the intended end state: anything left out is
   * removed, so the page can add and delete rows freely before saving.
   */
  replaceForEvent: async (
    eventId: string,
    contacts: ContactDTO[],
  ): Promise<ContactDTO[]> => {
    const res = await axiosInstance.put<ContactDTO[]>(
      `event/${eventId}/contacts`,
      contacts,
    );
    return res.data;
  },
};
